module.exports = __webpack_public_path__ + "img/ic_loc_details.92d7eb9a.svg";